var $__placeholder__0 = $__placeholder__1


/** WEBPACK FOOTER **
 ** ../@traceur/generated/TemplateParser/7
 **/